import React from 'react';
import { Button, Input } from '@tlx/atlas';
import { AltinnData } from '@Page/SalaryTaxCard/reducers/altinnHandling';
import { FormattedMessage, useIntl } from 'react-intl';

interface SearchProps {
    altinn?: AltinnData;
    search?: string;
    setSearch?: (value: string) => void;
    setOpen?: (value: boolean) => void;
}

export default function TaxCardMainTableToolbar({ altinn, search, setSearch, setOpen }: SearchProps) {
    //Puts a sticky 'Fetch taxcards' button on the table-toolbar when you scroll out of view of the original button
    const originalFetchTaxcardsButton = document.querySelector('[data-testId="fetch-taxcard-button"]');
    const stickyFetchTaxcardsButton = document.querySelector('[data-testId="getTaxcardsButton--sticky"]');
    const observer = new IntersectionObserver(([e]) => {
        stickyFetchTaxcardsButton?.classList.toggle('show', !e.isIntersecting);
    });

    if (originalFetchTaxcardsButton) {
        observer.observe(originalFetchTaxcardsButton);
    }

    const justLogIn = !altinn?.isLoggedInUntil && altinn?.isOlderWaitingTaxcardApplications;

    return (
        <div className="taxcardOverview-toolbar atl-flex atl-justify-between atl-p-8">
            <Search search={search} setSearch={setSearch} />
            <div className="atl-flex atl-flex-row atl-items-center">
                {/*future toolbar buttons on the right of the screen should be added here*/}
                {!justLogIn && (
                    <Button
                        data-testid="getTaxcardsButton--sticky"
                        className="getTaxcardsButton--sticky atl-mr-8"
                        onClick={() => setOpen?.(true)}
                        disabled={altinn?.isWaitingForAltinn}
                    >
                        <FormattedMessage id="text_get_taxcards" />
                    </Button>
                )}
            </div>
        </div>
    );
}

function Search({ search, setSearch }: SearchProps) {
    const intl = useIntl();
    return (
        <form
            onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                e.preventDefault();
                if (e.target instanceof HTMLFormElement) {
                    const formData = new FormData(e.target);
                    if (setSearch) {
                        setSearch(String(formData.get('searchQuery')));
                    }
                }
            }}
        >
            <Input
                data-testid="searchQueryTestId"
                type="search"
                name="searchQuery"
                autoComplete="off"
                onChange={(e) => {
                    /* If they remove the query, it updates the search setState and refreshes the table (This is for both when they press the x, or remove the query with backspace manually */
                    if (setSearch && !e.currentTarget.value) {
                        setSearch(e.currentTarget.value);
                    }
                }}
                placeholder={intl.formatMessage({ id: 'text_search' })}
                defaultValue={search}
            />
        </form>
    );
}
